const ViewTicketFullContentLoader = () => {
  return (
    <div className="p-5 bg-white rounded-[20px] shadow-[0px_0px_4px_0px_rgba(166,166,166,0.25)]">
      <div className="flex justify-between">
        <div className="h-4 w-1/4 bg-light_gray rounded-sm animate-pulse"></div>
        <div className="h-4 w-1/4 bg-light_gray rounded-sm animate-pulse"></div>
      </div>

      <div className="mt-5 h-16 bg-light_gray rounded-sm animate-pulse"></div>

      <div className="my-6 h-2 bg-light_gray rounded-sm animate-pulse"></div>

      <div className="flex flex-col space-y-2">
        <div className="h-4 bg-light_gray rounded-sm animate-pulse"></div>
        <div className="h-4 bg-light_gray rounded-sm animate-pulse"></div>
        <div className="h-4 bg-light_gray rounded-sm animate-pulse"></div>
      </div>
    </div>
  );
};

export default ViewTicketFullContentLoader;
